module.exports = __webpack_public_path__ + "img/miragejs.c1c2c40.jpg";